import {Injectable} from '@angular/core';
import {ExamFormModel} from "../../../api/model/exam-form.model";
import {ExamFormDataService} from "./examFormData.service";
import {ExamFormSummaryConverter} from "../../../api/converter/examFormSummary.converter";
import {ExamFormSummaryModel} from "../../../api/model/examFormSummary.model";
import {
    AbstractDataServiceDtoSummaryAdapter
} from "../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter";

@Injectable()
export class ExamFormSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<ExamFormSummaryModel, ExamFormSummaryConverter, ExamFormModel> {
    constructor(dataService: ExamFormDataService, converter: ExamFormSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ExamFormModel {
        return new ExamFormModel();
    }
}
